<script setup lang="ts">
import BaseNotificationPanel from '@/components/base/BaseNotificationPanel.vue'

defineOptions({
  name: 'OutgoingPaymentInformation'
})
</script>

<template>
  <BaseNotificationPanel status="warning">
    <p class="text-sm">
      {{ $t('entry.has_upcoming_payment_paying') }}
    </p>
  </BaseNotificationPanel>
</template>
